import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-span-9 row-start-1 row-end-5 lg:col-span-4 w-full block group focus:outline-none" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "grid h-full place-items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "There are no items in the checklist", -1)
const _hoisted_6 = [
  _hoisted_5
]

import {
  ref, toRefs, PropType,
} from 'vue';
import { ICheckList } from '@/models';
import { formatDate, handleImageError } from '@/util/funcs';


export default /*#__PURE__*/_defineComponent({
  props: {
  timelinecard: {
    type: Boolean,
    default: true,
  },
  selectedCheckListItemData: {
    type: Object as PropType<ICheckList>,
    required: true,
  },
},
  setup(__props) {

const props = __props


const { selectedCheckListItemData } = toRefs(props);
const isImageError = ref(false);

const error = (event: any) => {
  handleImageError(event);
  isImageError.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_unref(selectedCheckListItemData).checkListTitle)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["grid-cols-9 gap-x-8 gap-y-6", {'grid':!__props.timelinecard, 'flex flex-col':__props.timelinecard}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-full bg-gray-200 overflow-hidden", {'aspect-w-100 aspect-h-100 xl:aspect-w-100 xl:aspect-h-75':!__props.timelinecard, 'aspect-w-100 aspect-h-50 xl:aspect-w-100 xl:aspect-h-75':__props.timelinecard}])
          }, [
            _createElementVNode("img", {
              src: _unref(selectedCheckListItemData).checkListImage,
              alt: _unref(selectedCheckListItemData).checkListTitle,
              class: _normalizeClass([[!isImageError.value ? 'object-center object-cover' : 'p-2'], "group-hover:opacity-85 transition-opacity duration-300 ease-in-out bg-wrh-gray-lighter"]),
              onError: error
            }, null, 42, _hoisted_2)
          ], 2)
        ]),
        _createElementVNode("h3", {
          class: _normalizeClass(["t-22m text-wrh-blue-dark col-start-5 col-end-10", {'t-32m':!__props.timelinecard, '-order-1 lg:block':__props.timelinecard}])
        }, _toDisplayString(_unref(selectedCheckListItemData).checkListTitle), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["t-14r text-wrh-blue-light flex flex-col items-start justify-start col-start-5 col-end-10", {'':!__props.timelinecard, 'hidden':__props.timelinecard}])
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(selectedCheckListItemData).updatedBy ? `${_unref(selectedCheckListItemData).updatedBy.firstName} ${_unref(selectedCheckListItemData).updatedBy.lastName}` : ''), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(_unref(selectedCheckListItemData).updatedAt)), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([{'t-16r space-y-6':!__props.timelinecard,
      't-12r md:t-14r space-y-4 lg:t-16r':__props.timelinecard},
      'text-wrh-gray-darken text-left col-start-5 col-end-10'])
        }, [
          _createElementVNode("p", {
            innerHTML: _unref(selectedCheckListItemData).checkListDescription
          }, null, 8, _hoisted_3)
        ], 2)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
}
}

})